export default "__VITE_ASSET__DdICS1ux__"